module.exports = __webpack_public_path__ + "img/side_bg.4af8c5b5.jpg";